import type {
  TableHeaderColumn,
  TableProps,
} from "@kanda-libs/ks-component-ts";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectors } from "store";
import companySelectors from "store/selectors/company";
import { DEFAULT_COLUMN, TABLE_COLUMNS } from "./constants";
import { rateToTableRow, sortRates } from "./helpers";
import useCompanyRatesTableSorting from "./useCompanyRatesTableSorting";

export type CompanyRatesTablePropsHook = TableProps;

export default function useCompanyRatesTableProps(): CompanyRatesTablePropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const company = useSelector(companySelectors.getEntity);
  const rates = company?.finance_rates || [];

  const { sorting, order, ...sortingProps } = useCompanyRatesTableSorting();

  const data = useMemo(
    () =>
      sortRates(
        rates.map((rate) => rateToTableRow(rate)),
        sorting,
        order
      ),
    [rates, sorting, order]
  );

  return {
    ...sortingProps,
    isLoading,
    data,
    compact: true,
    onRowClicked: () => {},
    totalPages: 1,
    pageIndex: 0,
    setPage: () => {},
    columns: TABLE_COLUMNS as unknown as TableHeaderColumn[],
    defaultColumn: DEFAULT_COLUMN as unknown as TableHeaderColumn,
  };
}
